import { Building2, BookText, Globe, Images, LayoutTemplate, ListChecks, Rocket, SquarePlus, } from 'lucide-react';
import { NewRoute } from './routes/duplicate-launch.js';
import { BatchesPage } from './routes/batches.js';
import { BatchPage } from './routes/batch.js';
import { LaunchPage } from './routes/launch.js';
import { TemplatesPage } from './routes/templates.js';
import { TemplatePage } from './routes/template.js';
import { MediaPage } from './routes/media.js';
import { AccountsPage } from './routes/accounts.js';
import { AccountPage } from './routes/account.js';
import { JournalPage } from './routes/journal.js';
import { JOURNAL_AVAILABLE_KEY, journalAvailable } from './components/journal-link.js';
import { CountryListsPage } from './routes/country-lists.js';
// Проверка «журнал включён» — одна на модуль: пункт меню и кнопка тоста
// [Подробнее в журнале] (`components/journal-link.tsx`).
export { journalAvailable } from './components/journal-link.js';
/**
 * Раздел «Запуски FB» пространства «Реклама» — конструктор запусков Meta
 * через шлюз admin-api `/api/ads/*` к auto-ads. Формы строятся по дескриптору
 * реестра полей auto-ads: новое поле реестра появляется в UI без правок
 * модуля, если для его `type` уже есть виджет.
 *
 * Модуль отсоединяемый: импортирует только кит (`ui`, `ui-domain`,
 * `ui-forms`), `admin-client-core` и `admin-contracts` (ESLint allowlist).
 */
export const adsLauncherModule = {
    id: 'fb-launches',
    label: 'Запуски FB',
    icon: Rocket,
    permission: 'ads.read',
    workspace: 'ads',
    order: 10,
    description: 'Конструктор запусков Facebook: шаблон → кабинеты → креативы → проверка → запуск.',
    showInNav: true,
    sectionsPlacement: 'sidebar',
    // Новая оболочка: заголовок — хлебная крошка, описание — ⓘ, кнопки — в навбаре.
    routeChrome: 'shell',
    sections: [
        { path: '/new', label: 'Новый запуск', icon: SquarePlus },
        { path: '/', label: 'Запуски', icon: ListChecks },
        { path: '/templates', label: 'Шаблоны', icon: LayoutTemplate },
        { path: '/media', label: 'Медиатека', icon: Images },
        { path: '/accounts', label: 'Кабинеты', icon: Building2 },
        { path: '/country-lists', label: 'Списки стран', icon: Globe },
        // Журнал виден, только пока он включён на сервере (404 `ads_request_log_disabled` — пункта нет).
        {
            path: '/journal',
            label: 'Журнал',
            icon: BookText,
            availability: {
                // вне префикса ['ads', …]: инвалидация данных раздела проверку не дёргает
                queryKey: JOURNAL_AVAILABLE_KEY,
                queryFn: journalAvailable,
            },
        },
    ],
    routes: [
        { path: '/', component: BatchesPage },
        // липкий низ формы прилипает к окну, только если <main> шелла не прокручивается (E-2 P2-11)
        { path: '/new', component: NewRoute, layout: 'page-sticky' },
        { path: '/batches/$id', component: BatchPage, label: 'Пачка' },
        { path: '/launches/$id', component: LaunchPage, label: 'Запуск' },
        { path: '/templates', component: TemplatesPage },
        {
            path: '/templates/new',
            component: TemplatePage,
            label: 'Новый шаблон',
            layout: 'page-sticky',
        },
        { path: '/templates/$id', component: TemplatePage, label: 'Шаблон', layout: 'page-sticky' },
        { path: '/media', component: MediaPage },
        { path: '/accounts', component: AccountsPage },
        { path: '/accounts/$id', component: AccountPage, label: 'Кабинет' },
        { path: '/country-lists', component: CountryListsPage },
        { path: '/journal', component: JournalPage },
    ],
};
export { ADS_LAUNCHER_NO_PERMS, AdsLauncherModulePermsProvider, adsLauncherPermsFrom, useAdsLauncherPerms, } from './perms.js';
export { setAdsLauncherApiBaseUrl, adsIssuesOf } from './api.js';
export { uploadAsset, mediaKindOf } from './upload.js';
//# sourceMappingURL=index.js.map